'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
function flex() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$direction = _ref.direction,
      direction = _ref$direction === undefined ? 'row' : _ref$direction,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === undefined ? 'nowrap' : _ref$wrap,
      _ref$grow = _ref.grow,
      grow = _ref$grow === undefined ? 0 : _ref$grow,
      _ref$shrink = _ref.shrink,
      shrink = _ref$shrink === undefined ? 1 : _ref$shrink,
      _ref$basis = _ref.basis,
      basis = _ref$basis === undefined ? 'auto' : _ref$basis;

  return {
    display: 'flex',
    flexDirection: direction,
    flexGrow: grow,
    flexShrink: shrink,
    flexBasis: basis,
    flexWrap: wrap
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/styles/flex.js
// module id = 70
// module chunks = 0